<template>
<div class="bahasa">
    <div class="uk-container">
         <router-link to="/privacy/bahasa" style="color : black">Bahasa </router-link> | <router-link to="/privacy/english" style="color : black">English </router-link><br><br>    
        <div class="uk-flex-center@m">
            <center>
                <h3><b>KEBIJAKANAN PRIVASI PENYELENGGARA PLATFORM</b></h3>
                <h3><b>PT. SUMBER MEDIA KOMUNIKASI </b></h3>
            </center>
            <p>Kebijakan Privasi ini menjelaskan bagaimana informasi tentang Anda diperoleh dan diproses oleh PT. Sumber Media Komunikasi (SMK) dan memberikan informasi penting lainnya mengenai privasi, serta menjelaskan kapan dan bagaimana kami dapat mengubah Kebijakan Privasi ini. Kami berkomitmen untuk selalu menjaga data pribadi pelanggan kami dan kami telah menerapkan langkah-langkah yang diperlukan untuk menjaga keamanan data pribadi Anda.</p>
            <p>Kebijakan Privasi ini berlaku dalam pemrosesan Data Pribadi oleh SMK ketika Anda menggunakan jaringan kami, mengunjungi situs web kami, serta ketika Anda menggunakan atau menerima produk dan/atau layanan kami.</p>
            <p>Untuk keperluan Kebijakan Privasi ini:<br>
            “Data Pribadi” adalah setiap informasi terkait dengan pelanggan SMK yang diberikan oleh pelanggan kepada SMK atau tersedia untuk SMK karena adanya kontrak pelanggan dengan SMK, contoh: nama, nomor KTP/Paspor, informasi transaksi pelanggan dengan SMK seperti informasi kontak, informasi kartu kredit/debit dan rekening bank, lokasi telepon genggam (untuk mengaktifkan sambungan ke jaringan kami), riwayat penjelajahan, rekaman panggilan ke pusat layanan atau layanan pelanggan dan aktivitas akun; kata-kata “Anda” dan “pelanggan” termasuk pelanggan SMK yang lalu, saat ini dan di masa depan, termasuk pelanggan penyedia jaringan lainnya yang bekerja sama dengan SMK;</p>
            <h4><b>BAGAIMANA INFORMASI TENTANG ANDA DIPEROLEH:</b></h4>
            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li>Untuk dapat menggunakan jaringan dan/atau untuk menerima produk dan/atau layanan kami membutuhkan Data Pribadi Anda. Setiap kegagalan dalam memenuhi persyaratan tersebut atau setiap kekurangan pengungkapan Data Pribadi akan menyebabkan kami tidak dapat memproses permohonan Anda, sehingga Anda tidak dapat menikmati layanan, fitur, atau produk.</li>
                        <li>Ketika Anda mendaftar untuk produk dan layanan kami, berarti Anda telah memberikan persetujuan kepada kami untuk mengumpulkan dan memproses (menggunakan, mengolah, merekam, menahan, menyimpan, memberikan dan mengungkapkan) Data Pribadi Anda.</li>
                        <li>Dengan terus menggunakan jaringan kami, mengunjungi situs web kami, atau menggunakan produk dan/atau layanan kami berarti Anda telah memberikan persetujuan Anda kepada kami untuk memproses Data Pribadi Anda. Kami akan menyimpan catatan persetujuan Anda tersebut sebagaimana yang terlihat dalam basis data pelanggan aktif kami.</li>
                        <li>Data Pribadi Anda dapat diperoleh dari berbagai aktivitas dan sumber. Data Pribadi dapat dikumpulkan, termasuk namun tidak terbatas, ketika Anda mengisi formulir permohonan, ketika Anda menghubungi kami untuk memberikan pertanyaan atau permintaan bantuan, dari panggilan dan jaringan yang Anda lakukan, termasuk dari setiap pihak ketiga yang Anda beri kewenangan dan persetujuan untuk memproses Data Pribadi Anda. Data Pribadi Anda juga dapat dikumpulkan dari sumber informasi yang tersedia di publik dan ketika Anda mengunjungi situs web dan aplikasi kami, berpartisipasi dalam survey, mengadakan hubungan usaha dengan kami, atau ketika Anda menyampaikan keluhan kepada kami.</li>
                        <li>Layanan kami dapat merekam dan menyimpan data yang didapatkan dari produk-produk smart home yang digunakan oleh Anda. Data Pribadi Anda juga dapat diperoleh dari produk-produk smart home yang Anda gunakan. </li>
                        <li>Data Pribadi Anda akan disimpan untuk tujuan pada saat perolehan dan pemrosesan, atau untuk mematuhi setiap persyaratan internal, peraturan dan hukum.</li>
                    </ul>
                </div>
            </div>
            <h4><b>BAGAIMANA INFORMASI TENTANG ANDA DIGUNAKAN:</b></h4>
            <p>Kami menggunakan informasi yang kami peroleh untuk berbagai alasan:</p>
            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li>untuk menilai, validasi, dan memenuhi permintaan pembelian Anda, memverifikasi identitas Anda, mengakifkan dan/atau menon-aktifkan layanan yang Anda minta, termasuk untuk mengadakan dan memelihara layanan berkelanjutan kepada Anda;</li>
                        <li>untuk memproses tagihan dan pembayaran Anda, termasuk mengirimkan tagihan, memelihara catatan keuangan, menilai atau verifikasi rincian kartu kredit/debit;</li>
                        <li>untuk menyediakan dukungan teknis kepada Anda dan memelihara basis data umum pelanggan, termasuk untuk merespon pertanyaan dan menyelesaikan keluhan Anda;</li>
                        <li>untuk memahami kebutuhan dan minat Anda, termasuk untuk mengidentifikasi dan merekomendasikan produk atau layanan yang sesuai dengan kebutuhan Anda, serta untuk mengembangkan, meningkatkan, atau memberikan produk dan layanan yang dipersonalisasi, termasuk penawaran layanan dan promosi; dan </li>
                        <li>Untuk mematuhi kewajiban dalam perizinan, peraturan perundang-undangan dan persyaratan lainnya termasuk untuk memenuhi permintaan dari penegak hukum, institusi pemerintah, termasuk badan pengadilan dalam menyelidiki dan menyelesaikan setiap masalah atau perselisihan Anda terhadap kami, termasuk untuk pembelaan atas tuduhan terhadap atau sebaliknya melibatkan kami.</li>
                    </ul>
                </div>
            </div>
            <h4><b>BAGAIMANA INFORMASI TENTANG ANDA DIUNGKAPKAN:</b></h4>
            <p>Kami dapat mengungkapkan Data Pribadi Anda kepada pihak ketiga sebagai berikut:</p>
            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li>kepada institusi yang bertindak sebagai kontraktor yang membantu kami dalam menyediakan jaringan, produk dan/atau layanan kepada Anda;</li>
                        <li>kepada institusi yang bertindak sebagai saluran pembayaran kami untuk tujuan memelihara catatan keuangan, menilai atau verifikasi rincian kartu kredit/debit dan memfasilitasi pembayaran yang terhutang kepada kami;</li>
                        <li>kepada badan pengatur, institusi penegak hukum dan otoritas pemerintah untuk tujuan proses hukum dan kepatuhan terhadap persyaratan berdasarkan hukum atau untuk mendeteksi atau mencegah kejahatan dan/atau penipuan; atau</li>
                        <li>kepada mitra bisnis terpercaya dan mitra strategis kami untuk mengirimkan komunikasi pemasaran tentang produk dan/atau layanan kepada Anda berdasarkan pilihan dan minat Anda.  </li>
                    </ul>
                </div>
            </div>
            <h4><b>SITUS WEB www.roomi.co.id</b></h4>
            <p>Kami dapat meminta informasi standar seperti login ID, kata sandi, Data Pribadi, detail kontak dan nomor identifikasi untuk tujuan verifikasi dalam penggunaan situs kami. Anda dianjurkan untuk tidak mengungkapkan login ID dan kata sandi Anda untuk mengakses situs kami kepada siapa pun. Kami tidak akan bertanggung jawab atas pengungkapan Data Pribadi apabila Anda mengungkapkan login ID dan pasword kepada selain diri Anda.</p>

            <h4><b>ALAMAT IP DAN COOKIES</b></h4>
            <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                        <li>Sebagai bagian dari pemberian layanan internet dan untuk tujuan keamanan, kami dapat mengumpulkan dan mengelola alamat IP.</li>
                        <li>Kami juga dapat menggunakan informasi yang diperoleh dari cookies atau teknologi lainnya yang serupa untuk meningkatkan mutu situs web kami, memberikan rekomendasi, dan memenuhi transaksi yang Anda minta. Anda dapat mengkonfigurasikan dan mempersonalisasi peramban Anda saat ini untuk menolak atau menghapus cookies tersebut. </li>
                    </ul>
                </div>
            </div>
            <h4><b>PENGHENTIAN LAYANAN</b></h4>
            <p>SMK dapat  menghentikan Layanan sepihak apabila terjadi hal-hal sebagai berikut :</p>
             <div class="uk-child-width-expand@s" uk-grid>
                <div>
                     <ul class="uk-list uk-list-hyphen">
                        <li>Anda tidak melakukan hal-hal yang diatur dalam Kebijakan Privasi ini;</li>
                        <li>Anda sudah tidak memiliki kewenangan sebagai subyek hukum sesuai ketentuan hukum yang berlaku; atau</li>
                        <li>Anda tidak melakukan pembayaran biaya Layanan sesuai ketentuan yang telah disepakati.</li>
                    </ul>
                </div>
            </div>

            <h4><b>TAUTAN KE SITUS WEB ATAU LAYANAN LAIN </b></h4>
            <p>Apabila ada bagian dari situs web kami yang menghubungkan Anda ke situs web lain, kami tidak bertanggung jawab terhadap risiko yang timbul dari situs web lain tersebut karena situs web tersebut tidak dioperasikan berdasarkan Kebijakan Privasi ini.</p>
            <p>Kami dapat memperbarui Kebijakan Privasi ini. Kunjungi situs web kami untuk melihat perubahan terhadap Kebijakan Privasi ini. Dengan tetap berkomunikasi dengan kami, menggunakan jaringan kami, mengunjungi situs web kami dan/atau menggunakan atau menerima produk dan/atau layanan kami, berarti Anda telah menyetujui dan menerima pembaharuan tersebut.</p>

            <h4><b>PEMBEBASAN TANGGUNG JAWAB </b></h4>
            <p>Anda secara sadar bersedia bertanggung jawab secara penuh atas segala tindakan yang dilakukannya dan membebaskan SMK dan anak perusahaan, afiliasi, pemegang saham, direksi, komisaris, karyawan SMK, sepenuhnya dari segala tuntutan, kerugian, pembayaran maupun biaya apapun yang timbul yang diderita oleh Anda baik secara langsung maupun tidak langsung, sebagai akibat penggunaan layanan kami, termasuk tata cara perolehan, penggunaan, pengungkapan serta pemyimpanan  Data Pribadi sebagaimana diatur dalam Kebijakan Privasi ini.</p>

            <h4><b>PENYELESAIAN PERSELISIHAN</b></h4>
            <P>Apabila di kemudian hari terjadi perselisihan maka Anda setuju untuk menyelesaikan secara musyawarah dan mufakat. Apabila musyawarah tidak mencapai mufakat dalam kurun waktu 30 (tiga puluh) hari sejak tanggal musyawarah dilakukan pertama kali, maka Anda sepakat untuk menyelesaikan perselisihan tersebut melalui pengadilan dan memilih domisili hukum yang tetap dan umum yaitu Badan Arbitrase Nasional Indonesia (BANI) di Mampang – Jakarta Selatan, yang mana keputusannya bersifat final dan mengikat. </P>
            <!-- <div class="uk-child-width-expand@s" uk-grid>
                <div>
                    <ul class="uk-list uk-list-decimal">
                    </ul>
                </div>
            </div> -->
        </div>
        <br>
        <br>
    </div>
</div>
</template>

<script>
export default {
    props: ['productName', 'description', 'features', 'price', 'link', 'img', 'imgScale', 'imgPositionX', 'imgPositionY', 'spesification'],
    data () {
        return {
            product: this.productName,
            image: require('../assets/roomi_web-02.jpg'),
            imagess: require('../assets/Frame 18.jpg'),
        }
    },
    mounted () {
        
    }
}
</script>

<style scoped>
#product-spesification .uk-section {
    padding-bottom: 80px;
}

#top-section {
    border: 1px solid rgb(67, 67, 68);
    border-radius: 10px;
    height: 350px;
}

#product-features {
    padding: 40px 0 40px 40px;
}

#product-features div {
    margin-top: 2vw;
}

#product-features h3 {
    margin-bottom: 0;
    font-size: 20px;
    letter-spacing: .3vw;
    color: rgb(95, 103, 105);
    line-height: normal;
}

#product-features p {
    color: rgb(194, 195, 197);
    letter-spacing: 2px;
    font-weight: 100;
    line-height: 1;
    font-size: 1.1vw;
    margin-bottom: 2.5vw;
}

p.price {
    color: #403f41;
}

#product-features ul {
    padding-left: 0;
    list-style-position: inside;
    margin-bottom: 3vw;
}

#product-features ul li {
    font-size: .70vw;
    margin-bottom: 15px;
}

#product-features a.uk-button {
    border-radius: 10px;
    font-size: 11px;
    letter-spacing: 1px;
}

#trapezoid img {
    width: 100%;
}

@media screen and (max-width: 639px) {
    #top-section {
        height: auto;
        max-height: auto !important;
    }

    #product-features p {
        font-size: 14px;
    }

    #product-features ul li {
        font-size: 10px;
    }

}
</style>